import PropTypes from 'prop-types';
import { WeightPropType } from './weight';
import { DimensionPropType } from './dimension';

export const ShippingPresetPropType = PropTypes.shape({
  presetId: PropTypes.string,
  name: PropTypes.string,
  hotKey: PropTypes.string,
  presetOptions: PropTypes.shape({
    warehouseId: PropTypes.string,
    packageTypeId: PropTypes.string,
    confirmationId: PropTypes.string,
    insuranceProviderId: PropTypes.string,
    shippingService: PropTypes.shape({
      providerId: PropTypes.string,
      serviceId: PropTypes.string,
      sellerLabelProviderId: PropTypes.string,
      serviceCollectionGuid: PropTypes.string,
    }),
    fulfillmentService: PropTypes.shape({
      fulfillmentProviderId: PropTypes.string,
      fulfillmentServiceId: PropTypes.string,
    }),
    weight: WeightPropType,
    dimensions: DimensionPropType,
  }),
});

/**
 * @typedef {object} ShippingPresetPropType
 * @property {string} presetId
 * @property {string} name
 * @property {string} hotKey
 * @property {object} presetOptions
 * @property {string} presetOptions.warehouseId
 * @property {string} presetOptions.packageTypeId
 * @property {string} presetOptions.confirmationId
 * @property {string} presetOptions.insuranceProviderId
 * @property {object} presetOptions.shippingService
 * @property {string} presetOptions.shippingService.providerId
 * @property {string} presetOptions.shippingService.serviceId
 * @property {string} presetOptions.shippingService.sellerLabelProviderId
 * @property {string} presetOptions.shippingService.serviceCollectionGuid
 * @property {object} presetOptions.fulfillmentService
 * @property {string} presetOptions.fulfillmentService.fulfillmentProviderId
 * @property {string} presetOptions.fulfillmentService.fulfillmentServiceId
 * @property {WeightPropType} presetOptions.weight
 * @property {DimensionsPropType} presetOptions.dimensions
 */
